var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconKey = function SvgIconKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.562 6.88a3 3 0 0 1 4.226-.37l3.064 2.57a2 2 0 0 1-2.57 3.065l-2.298-1.929-2.25 2.682 2.298 1.928a2 2 0 1 1-2.572 3.064l-2.298-1.928L20.18 21.9a8.001 8.001 0 1 1-3.065-2.572zM16.238 23.484a4 4 0 1 0-5.142 6.129 4 4 0 0 0 5.142-6.129"
  })));
};
export default SvgIconKey;